import { Grid, Tab, Tabs, Typography } from "@mui/material";
import { Link, Route, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useRouteMatch } from "../../../../Helpers/RouteMatcher";
import { OrganisationAtom } from "../../../../State/Organisation.Atom";
import { OrganisationExternalTraining } from "./External/OrganisationExternalTraining";
import { OrganisationInternalTraining } from "./Internal/OrganisationInternalTraining";
import { OrganisationLAITraining } from "./LAI/OrganisationLAITraining";

export const OrganisationTraining = () => {
    const peopleAndTrainingOrganisation = useRecoilValue(OrganisationAtom);
    const routes = [
        "/organisation/training/External",
        "/organisation/training/Internal",
        "/organisation/training/LAI",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;


    return (
        <>
            <Typography variant="h4" style={{ paddingBottom: "20px" }}>
                Manage Training
            </Typography>
            <Typography variant="body2" style={{ paddingBottom: "20px" }}>
                Manage your historic and upcoming training for {peopleAndTrainingOrganisation.OrganisationName}.
            </Typography>

            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        <Tab label="External" value={routes[0]} to={routes[0]} component={Link} />
                        <Tab label="Internal" value={routes[1]} to={routes[1]} component={Link} />
                        <Tab label="LAI's" value={routes[2]} to={routes[2]} component={Link} />
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={3}>
                    <Switch>
                        <Route path={routes[0]}>
                            <OrganisationExternalTraining />
                        </Route>
                        <Route path={routes[1]}>
                            <OrganisationInternalTraining />
                        </Route>
                        <Route path={routes[2]}>
                            <OrganisationLAITraining />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}